<template>
    <div class="element--content">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-xl-12">
                    <div v-if="data.showTitle">
                        <h2 v-if="data.titleUseH2" class="element-title">{{data.title}}</h2>
                        <h4 v-else class="medium element-title">{{data.title}}</h4>
                    </div>

                    <div class="wysiwyg-content" v-tablecleanup v-html="data.content"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "element-text",
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                
            }
        },
        created() {
            const app = this;
            let emitClass = {
                refIndex: this.data.refIndex,
                offset: 0,
                class: null
            };

            emitClass.offset = -1;
            emitClass.class = 'next-is-content-element';
            app.$emit('addNeighbourClass', emitClass);

            emitClass.offset = 1;
            emitClass.class = 'prev-is-content-element';
            app.$emit('addNeighbourClass', emitClass);
        }
    };
</script>

<style lang="scss" scoped>
    h2.element-title,
    h4.element-title {
        margin-bottom: 0;    
    }

    // .wysiwyg-content {
    //     :first-child {
    //         margin-top: 0;
    //     }

    //     :last-child {
    //         margin-bottom: 0;
    //     }
    // }
</style>
